import React from 'react';

const DuplicateIcon = () => (<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.5 0.5H0.5V11.5H11.5V0.5Z" stroke="#7A7D85" strokeLinecap="round" strokeLinejoin="round"/><path d="M13.5 4.5H15.5V15.5H4.5V13.5" stroke="#7A7D85" strokeLinecap="round" strokeLinejoin="round"/></svg>);

export default DuplicateIcon;
